import React, { useEffect } from 'react'
// eslint-disable-next-line
import { Routes, Route, Link } from "react-router-dom";
import { Container, Dropdown, Nav, Badge, Navbar, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faBell, faBurger, faCog, faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-regular-svg-icons'
import { colors } from '../../../tools/constants';
import { get, put } from '../../../controllers/endpoints.controller';
import { getUserRole, getUserToken, logout, forceLogout } from '../../../controllers/user.controller';
import { timeSince } from '../../../tools/tools';
import { params } from '../../../tools/constants'

export default function NavBar() {
    const [notifications, setNotifications] = React.useState([]);
    const [menus, setMenus] = React.useState([]);
    const [menusMobile, setMenusMobile] = React.useState([]);
    const [isMenuOpened, setMenuOpened] = React.useState(false);

    useEffect(() => {
        processMenus()
        // getMyNotifications()

    }, []);

    const handleMobileMenu = () => {
        setMenuOpened(!isMenuOpened);
    }

    const getMyNotifications = async function () {
        const req = await get(`/notifications`, getUserToken());
        const res = await req.json();

        if (req.status === 200) {
            setNotifications(res);
        } else if (req.status === 403) {
            logout();
        } else {
            alert(res.message);
        }
    }

    const setNotificationAsSeen = async function (notificationId, url) {
        const req = await put(`/notifications/seen`, getUserToken(), { notificationId: notificationId });
        const res = await req.json();

        if (req.status === 200) {
            window.location.href = url;
        } else if (req.status === 403) {
            logout();
        } else {
            alert(res.message);
        }
    }

    const processMenus = () => {
        let m = [];
        let mm = [];
        const role = getUserRole();

        if (role == "Administrador") {
            m = [{ text: "Inicio", link: "/inicio" },
            { text: "Clientes", link: "/clientes" },
            { text: "Calendario", link: "/calendario" },
            { text: "Citas", link: "/citas" },
            { text: "Hoja de ruta", link: "/hojaderuta" },
            { text: "Administración", link: "/administracion" },
            { text: "Cuenta corriente", link: "/usuarios/cuentaCorriente" },
            { text: "Configuración", link: "/sistema" },];
        } else if (role == "Empleado") {
            m = [{ text: "Inicio", link: "/" },
            { text: "Clientes", link: "/clientes" },
            { text: "Cuenta corriente", link: "/usuarios/cuentaCorriente" },
            { text: "Configuración", link: "/sistema" },];
        } else if (role == "Cliente") {
            m = [{ text: "Judicial", link: "/expedientes" },
            { text: "Deudas", link: "/moras" }];
        }

        if (role == "Administrador") {
            mm = [{ text: "Inicio", link: "/inicio" },
            { text: "Clientes", link: "/clientes" },
            { text: "Calendario", link: "/calendario" },
            { text: "Citas", link: "/citas" },
            { text: "Hoja de ruta", link: "/hojaderuta" },
            { text: "Administración", link: "/administracion" },
            { text: "Cuenta corriente", link: "/usuarios/cuentaCorriente" },];
        } else if (role == "Empleado") {
            mm = [{ text: "Inicio", link: "/" },
            { text: "Clientes", link: "/clientes" },
            { text: "Cuenta corriente", link: "/usuarios/cuentaCorriente" },];
        } else if (role == "Cliente") {
            mm = [{ text: "Judicial", link: "/expedientes" },
            { text: "Deudas", link: "/moras" }];
        }

        setMenus(m)
        setMenusMobile(mm)
    }

    const checkPage = function (key) {
        const actualUri = window.location.pathname.split('/')[1];
        const actualMenu = menus[key].link.split('/')[1];

        if (actualUri === actualMenu) {
            return (
                <Link to={menus[key].link} className="navbar-menu-active pe-3 ps-3">{menus[key].text}</Link>
            )
        } else {
            return (
                <Link to={menus[key].link} className="navbar-menu-not-active pe-3 ps-3">{menus[key].text}</Link>
            )
        }
    };

    const checkMobilePage = function (key) {
        const actualUri = window.location.pathname.split('/')[1];
        const actualMenu = menus[key].link.split('/')[1];

        if (actualUri === actualMenu) {
            return (
                <Link to={menus[key].link} className="navbar-menu-active w-100 pe-3 ps-3">{menus[key].text}</Link>
            )
        } else {
            return (
                <Link to={menus[key].link} className="navbar-menu-not-active w-100 pe-3 ps-3">{menus[key].text}</Link>
            )
        }
    };

    return (
        <div style={{ marginBottom: 100 }}>
            <Navbar fixed="top" className="pb-2" style={{ background: "white" }}>
                <Container>
                    <Navbar.Brand>
                        <img
                            src="/logo.png"
                            height="60"
                            className="d-inline-block align-top"
                            alt="Plagamix"
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle />
                    <Navbar.Collapse className="justify-content-end">
                        <Navbar.Text className='me-3 d-none d-sm-block'>
                            
                        </Navbar.Text>

                        <Navbar.Text className='d-none d-sm-block'>
                            <Dropdown>
                                <Dropdown.Toggle variant="" id="dropdown-basic" style={{ background: `${colors().brand_primary}`, borderColor: `${colors().brand_primary}`, zIndex: '9' }}>
                                    <img className='avatar-10' src={`${params().dataUri}${localStorage.getItem('userAvatar')}`} alt=""></img>
                                    <span className="ms-3 me-3" style={{color: 'white'}}>{`${localStorage.getItem('userName')} ${localStorage.getItem('userSurname')}`}</span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={logout}><FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: 9 }} />Salir</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Navbar.Text>

                        <Navbar.Text className='d-block d-sm-none'>

                          


                        </Navbar.Text>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Navbar className='d-none d-sm-block' fixed="top" style={{ background: `${colors().brand_primary}`, marginTop: 85, zIndex: '10', height: 20 }}>
                <Container>
                    <Nav className="flex-grow-1 justify-content-center pb-0">
                        
                    </Nav>
                </Container>
            </Navbar>

        </div>
    )
}